import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "info-box" }
const _hoisted_4 = { class: "test-name" }
const _hoisted_5 = { class: "test-name" }
const _hoisted_6 = { class: "test-label" }
const _hoisted_7 = { class: "test-label" }
const _hoisted_8 = { class: "progress-box" }
const _hoisted_9 = { class: "progress" }
const _hoisted_10 = {
  key: 0,
  class: "step-container"
}
const _hoisted_11 = {
  key: 0,
  class: "step-header"
}
const _hoisted_12 = {
  key: 1,
  class: "test-overview"
}
const _hoisted_13 = {
  key: 2,
  class: "step-header"
}
const _hoisted_14 = {
  key: 3,
  class: "questionnaire-table"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 1,
  class: "step-container-hint"
}
const _hoisted_19 = { class: "link" }
const _hoisted_20 = {
  key: 2,
  class: "step-container"
}
const _hoisted_21 = {
  key: 0,
  class: "participant-table"
}
const _hoisted_22 = { class: "token-col" }
const _hoisted_23 = { class: "indicator" }
const _hoisted_24 = {
  key: 0,
  class: "wait"
}
const _hoisted_25 = {
  key: 1,
  class: "login"
}
const _hoisted_26 = {
  key: 2,
  class: "locked"
}
const _hoisted_27 = { class: "button-bar" }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { class: "questionnaire-table" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "question-header" }
const _hoisted_34 = { class: "question-options" }
const _hoisted_35 = { class: "option-list" }
const _hoisted_36 = { class: "option-text" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_WarnTriangleFilled = _resolveComponent("WarnTriangleFilled")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_Search = _resolveComponent("Search")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_ChatLineRound = _resolveComponent("ChatLineRound")
  const _component_Clock = _resolveComponent("Clock")
  const _component_Ticket = _resolveComponent("Ticket")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_Unlock = _resolveComponent("Unlock")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_Check = _resolveComponent("Check")
  const _component_Close = _resolveComponent("Close")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.TEST,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['TEST_UPDATE'] && !_ctx.loading]
        ]),
        (_ctx.testModel)
          ? (_openBlock(), _createBlock(_component_Breadcrumbs, {
              key: 0,
              breadcrumbs: [['Prüfungen', '/test'], [_ctx.testName, ('/test/'+_ctx.testModel.testid)], ['Durchführung']]
            }, null, 8, ["breadcrumbs"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "rounded-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("span", {
                              class: "test-label",
                              onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onBackToTestClick && _ctx.onBackToTestClick(...args)))
                            }, _toDisplayString(_ctx.testName), 1)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 12,
                        align: "right"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _cache[5] || (_cache[5] = _createTextVNode(" am ")),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.testDate))), 1),
                            _cache[6] || (_cache[6] = _createTextVNode(" um ")),
                            _createElementVNode("span", _hoisted_7, _toDisplayString(new Intl.DateTimeFormat('de-DE', {hour: '2-digit', minute: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.testDate))) + " Uhr", 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_el_steps, {
                      active: _ctx.step,
                      "finish-status": "success"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_step, {
                          title: "Schritt 1",
                          description: "Vorbereitung"
                        }),
                        _createVNode(_component_el_step, {
                          title: "Schritt 2",
                          description: "Kontrolle des Fragebogens"
                        }),
                        _createVNode(_component_el_step, {
                          title: "Schritt 3",
                          description: "Feststellung der Anwesenheit"
                        }),
                        _createVNode(_component_el_step, {
                          title: "Schritt 4",
                          description: "Durchführung der Prüfung"
                        })
                      ]),
                      _: 1
                    }, 8, ["active"])
                  ])
                ]),
                (_ctx.step == 1)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_ctx.step == 1 && _ctx.substep < 3)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_11, "Übersicht"))
                        : _createCommentVNode("", true),
                      (_ctx.step == 1 && _ctx.substep < 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createVNode(_component_el_row, { class: "overview-row" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: 3,
                                  class: "overview-label"
                                }, {
                                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                                    _createTextVNode(" Prüfungsumfang: ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  span: 14,
                                  class: "overview-value"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.testModel.questioncount) + " Fragen ", 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, { class: "overview-row" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: 3,
                                  class: "overview-label"
                                }, {
                                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                                    _createTextVNode(" Prüfungszeit: ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  span: 14,
                                  class: "overview-value"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.testModel.timelimit) + " Minuten ", 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, { class: "overview-row" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: 3,
                                  class: "overview-label"
                                }, {
                                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                                    _createTextVNode(" Befragungsart: ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  span: 14,
                                  class: "overview-value"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.testComplexity[_ctx.testModel.complexity]), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, { class: "overview-row" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: 3,
                                  class: "overview-label"
                                }, {
                                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                                    _createTextVNode(" Prüfung bestanden: ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  span: 14,
                                  class: "overview-value"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" bei " + _toDisplayString(_ctx.testModel.successpct) + "% korrekt beantworteter Fragen ", 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_row, { class: "overview-row" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, {
                                  span: 3,
                                  class: "overview-label"
                                }, {
                                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                                    _createTextVNode(" Zielgruppe(n): ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_el_col, {
                                  span: 14,
                                  class: "overview-value"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.targetgroupNames), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.step == 1 && _ctx.substep == 3)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_13, "Vorschau des Fragenkatalogs"))
                        : _createCommentVNode("", true),
                      (_ctx.step == 1 && _ctx.substep == 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (!_ctx.questionnaireModelList)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[12] || (_cache[12] = [
                                  _createElementVNode("p", null, "Es konnte kein Fragebogen aus dem Fragenkatalog erstellt werden.", -1),
                                  _createElementVNode("p", null, "Bitte stellen Sie sicher, dass Sie der Zielgruppe genügend Kategorien zugeordnet haben.", -1)
                                ])))
                              : _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                                  key: 1,
                                  data: _ctx.questionnaireModelList
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_table_column, {
                                      label: "Nr.",
                                      width: "50",
                                      align: "right"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createTextVNode(_toDisplayString(_ctx.questionnaireModelList[scope.$index].position), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "Frage" }, {
                                      default: _withCtx((scope) => [
                                        (_ctx.testModel.complexity == 1 && _ctx.questionnaireModelList[scope.$index].correctcount > 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.questionnaireModelList[scope.$index].question), 1))
                                          : _createCommentVNode("", true),
                                        (_ctx.testModel.complexity == 0 || _ctx.questionnaireModelList[scope.$index].correctcount == 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.questionnaireModelList[scope.$index].singlechoice), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      prop: "category",
                                      label: "Kategorie",
                                      width: "300"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      fixed: "right",
                                      label: "",
                                      width: "60"
                                    }, {
                                      default: _withCtx((scope) => [
                                        (_ctx.questionnaireModelList[scope.$index].totalcount < 5)
                                          ? (_openBlock(), _createBlock(_component_el_icon, {
                                              key: 0,
                                              title: "Diese Frage stellt nicht mindestens 5 Antwortmöglichkeiten zur Verfügung.",
                                              class: "warning"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_WarnTriangleFilled)
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      fixed: "right",
                                      label: "",
                                      width: "60"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createVNode(_component_el_button, {
                                          type: "primary",
                                          onClick: $event => (_ctx.onQuestionPreviewClick(_ctx.questionnaireModelList[scope.$index].questionid, (_ctx.testModel.complexity == 0 || _ctx.questionnaireModelList[scope.$index].correctcount == 1 ? _ctx.questionnaireModelList[scope.$index].singlechoice : _ctx.questionnaireModelList[scope.$index].question))),
                                          circle: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, { size: 16 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Search)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"])), [
                                  [_directive_loading, _ctx.loadingQuestions]
                                ])
                          ]))
                        : _createCommentVNode("", true)
                    ])), [
                      [_directive_loading, _ctx.generating]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.step == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 12 }, {
                            default: _withCtx(() => [
                              _cache[13] || (_cache[13] = _createTextVNode(" Einwahl für Prüflinge über: ")),
                              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.loginAddress), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, {
                            class: "question-button",
                            span: 12,
                            align: "right"
                          }, {
                            default: _withCtx(() => [
                              _cache[14] || (_cache[14] = _createTextVNode(" Prüfungsfragen:  ")),
                              _createVNode(_component_el_button, {
                                type: "success",
                                onClick: _cache[1] || (_cache[1] = $event => (_ctx.showQuestions = !_ctx.showQuestions)),
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ChatLineRound)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.step == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "step-header" }, "Übersicht über die Prüflinge", -1)),
                      (_ctx.step == 2 && _ctx.substep == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createVNode(_component_el_table, { data: _ctx.participantList }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                  label: "Teilnahme-ID",
                                  width: "200",
                                  align: "right"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.participantList[scope.$index].prefix + '-' + _ctx.participantList[scope.$index].token), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  fixed: "right",
                                  label: "",
                                  width: "50",
                                  align: "center"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createElementVNode("div", _hoisted_23, [
                                      (!_ctx.participantList[scope.$index].datelogin)
                                        ? (_openBlock(), _createBlock(_component_el_icon, {
                                            key: 0,
                                            class: "wait",
                                            size: 24
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Clock)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.participantList[scope.$index].datelogin)
                                        ? (_openBlock(), _createBlock(_component_el_icon, {
                                            key: 1,
                                            class: "login",
                                            size: 24
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Ticket)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  fixed: "right",
                                  label: "Status",
                                  width: "200"
                                }, {
                                  default: _withCtx((scope) => [
                                    (!_ctx.participantList[scope.$index].datelogin)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, "warten auf Anmeldung"))
                                      : _createCommentVNode("", true),
                                    (_ctx.participantList[scope.$index].datelogin && !_ctx.participantList[scope.$index].islocked)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, "angemeldet"))
                                      : _createCommentVNode("", true),
                                    (_ctx.participantList[scope.$index].islocked)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, "gesperrt"))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  fixed: "right",
                                  label: "",
                                  width: "250"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createVNode(_component_el_switch, {
                                      modelValue: _ctx.participantList[scope.$index].isignored,
                                      "onUpdate:modelValue": $event => ((_ctx.participantList[scope.$index].isignored) = $event),
                                      class: "option-switch",
                                      "active-text": "ignorieren",
                                      "inactive-text": "erforderlich",
                                      onChange: $event => (_ctx.onIgnoreChange(_ctx.participantList[scope.$index]))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  fixed: "right",
                                  label: "Zusätzliche Minuten",
                                  width: "400"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createVNode(_component_el_input_number, {
                                      modelValue: _ctx.participantList[scope.$index].extratime,
                                      "onUpdate:modelValue": $event => ((_ctx.participantList[scope.$index].extratime) = $event),
                                      min: 0,
                                      max: 240,
                                      onChange: $event => (_ctx.onExtraTimeChange(_ctx.participantList[scope.$index]))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  fixed: "right",
                                  label: "",
                                  width: "60",
                                  align: "center"
                                }, {
                                  default: _withCtx((scope) => [
                                    (_ctx.participantList[scope.$index].islocked)
                                      ? (_openBlock(), _createBlock(_component_el_button, {
                                          key: 0,
                                          type: "success",
                                          title: "Prüfling entsperren",
                                          onClick: $event => (_ctx.onUnlockParticipantClick(_ctx.participantList[scope.$index])),
                                          circle: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, { size: 16 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Unlock)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["data"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_27, [
                  (_ctx.step == 1 && _ctx.substep == 1)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        onClick: _ctx.onGenerateQuestionsClick,
                        disabled: _ctx.generating
                      }, {
                        default: _withCtx(() => _cache[16] || (_cache[16] = [
                          _createTextVNode("Fragebogen erstellen")
                        ])),
                        _: 1
                      }, 8, ["onClick", "disabled"]))
                    : _createCommentVNode("", true),
                  (_ctx.step == 1 && _ctx.substep == 2)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        onClick: _ctx.onGotoQuestionsClick,
                        disabled: _ctx.generating
                      }, {
                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                          _createTextVNode("Zum Fragebogen")
                        ])),
                        _: 1
                      }, 8, ["onClick", "disabled"]))
                    : _createCommentVNode("", true),
                  (_ctx.questionnaireModelList && _ctx.questionnaireModelList.length > 0 && !_ctx.allApproved())
                    ? (_openBlock(), _createElementBlock("span", _hoisted_28, " Es wurden noch nicht alle Fragen zur Verwendung freigegeben."))
                    : _createCommentVNode("", true),
                  (_ctx.step == 1 && _ctx.substep == 3 && (_ctx.testModel.statusid == _ctx.Status.TEST_PENDING || _ctx.testModel.statusid == _ctx.Status.TEST_START) && _ctx.allApproved())
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 3,
                        type: "primary",
                        onClick: _ctx.onGotoParticipantsClick
                      }, {
                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                          _createTextVNode("Fortfahren zur Feststellung der Anwesenheit")
                        ])),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.step == 2 && _ctx.testModel.statusid == _ctx.Status.TEST_PENDING && _ctx.allParticipantsReady)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 4,
                        type: "primary",
                        onClick: _ctx.onStartTestClick
                      }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode("Prüfung für alle Teilnehmenden starten")
                        ])),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.step == 2 && _ctx.testModel.statusid == _ctx.Status.TEST_START && _ctx.allParticipantsReady)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 5,
                        type: "primary",
                        onClick: _ctx.onWatchTestClick
                      }, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createTextVNode("Prüfungsverlauf anzeigen")
                        ])),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.hasPermission['TEST_UPDATE']]
        ]),
        _createVNode(_component_el_dialog, {
          title: "Vorschau des Fragebogens",
          modelValue: _ctx.showQuestions,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.showQuestions) = $event)),
          top: "70px",
          width: "80%",
          "show-close": false,
          modal: true,
          "modal-class": "no-back",
          center: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_29, [
              (!_ctx.questionnaireModelList)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _cache[21] || (_cache[21] = [
                    _createElementVNode("p", null, "Es konnte kein Fragebogen aus dem Fragenkatalog erstellt werden.", -1),
                    _createElementVNode("p", null, "Bitte stellen Sie sicher, dass Sie der Zielgruppe genügend Kategorien zugeordnet haben.", -1)
                  ])))
                : _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    key: 1,
                    data: _ctx.questionnaireModelList
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "Nr.",
                        width: "50",
                        align: "right"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(_ctx.questionnaireModelList[scope.$index].position), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, { label: "Frage" }, {
                        default: _withCtx((scope) => [
                          (_ctx.testModel.complexity == 1 && _ctx.questionnaireModelList[scope.$index].correctcount > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.questionnaireModelList[scope.$index].question), 1))
                            : _createCommentVNode("", true),
                          (_ctx.testModel.complexity == 0 || _ctx.questionnaireModelList[scope.$index].correctcount == 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.questionnaireModelList[scope.$index].singlechoice), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "category",
                        label: "Kategorie",
                        width: "300"
                      }),
                      _createVNode(_component_el_table_column, {
                        fixed: "right",
                        label: "",
                        width: "60"
                      }, {
                        default: _withCtx((scope) => [
                          (_ctx.questionnaireModelList[scope.$index].totalcount < 5)
                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                key: 0,
                                title: "Diese Frage stellt nicht mindestens 5 Antwortmöglichkeiten zur Verfügung.",
                                class: "warning"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WarnTriangleFilled)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        fixed: "right",
                        label: "",
                        width: "60"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: $event => (_ctx.onQuestionPreviewClick(_ctx.questionnaireModelList[scope.$index].questionid, (_ctx.testModel.complexity == 0 || _ctx.questionnaireModelList[scope.$index].correctcount == 1 ? _ctx.questionnaireModelList[scope.$index].singlechoice : _ctx.questionnaireModelList[scope.$index].question))),
                            circle: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, { size: 16 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Search)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])), [
                    [_directive_loading, _ctx.loadingQuestions]
                  ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          title: "",
          modelValue: _ctx.showQuestionPreview,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.showQuestionPreview) = $event)),
          top: "70px",
          width: "80%",
          "show-close": false,
          modal: true,
          "modal-class": "no-back",
          center: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.questionName), 1),
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_34, [
              (!_ctx.loadingOptions)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.optionModelList, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 0.1 }, {
                              default: _withCtx(() => [
                                (item.iscorrect)
                                  ? (_openBlock(), _createBlock(_component_el_icon, {
                                      key: 0,
                                      class: "correct"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Check)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (!item.iscorrect)
                                  ? (_openBlock(), _createBlock(_component_el_icon, {
                                      key: 1,
                                      class: "correct"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Close)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_col, { span: 0.1 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.position) + ".  ", 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_el_col, { span: 20 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.option), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]))
                  }), 256))
                : _createCommentVNode("", true)
            ])), [
              [_directive_loading, _ctx.loadingOptions]
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ])
  ], 64))
}